import { gql } from '@apollo/client';
import { EXPORT_INSTITUTION } from '../../fragments';

export const EXPORT_FUNDER_PROMOTION_SCHOOLS = gql`
  query ExportFunderPromotionSchools($input: ExportArgs!) {
    allFunderPromotionSchools(input: $input) {
      ...exportInstitution
    }
  }
  ${EXPORT_INSTITUTION}
`;
